/**
 * Behaviour for the colour stories on the custom colour page (WP5).
 *
 * The story cards are written in Liquid — title, story, link label — and the
 * colour facts on them are not. Liquid cannot read window.MCM_COLOURS, so each
 * card ships with an empty tile, an empty meta line and, when the merchant left
 * the link blank, an anchor with no href; this file resolves the card's
 * `colour_id` through window.JessieColour and fills them in (build plan §1.2,
 * §1.6 rule 2).
 *
 * Nothing here degrades into a placeholder. A card whose id names no colour, a
 * page where material-colours.js is blocked, a mistyped id: all three leave the
 * tile hidden, the meta line hidden and the link hidden, and the written card
 * reads exactly as it would have without them.
 *
 * The section may in principle be added to a page twice, and a repeated
 * <script src> re-executes, so the file carries the guard of §1.6 rule 7 and
 * init() marks every card it has already filled.
 */
(function () {
  'use strict';

  if (window.__jessie_stories) return;
  window.__jessie_stories = true;

  var FILLED = 'data-jessie-filled';

  function jc() {
    return window.JessieColour;
  }

  function all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  /**
   * One card. The tile and the meta line are painted only from a resolved row;
   * the link is revealed only once it has somewhere to go.
   */
  function fillCard(card) {
    if (!card || card.hasAttribute(FILLED)) return;
    card.setAttribute(FILLED, '');

    var id = card.getAttribute('data-jessie-story-id');
    if (!id) return;

    var row = jc().byId(id);
    if (!row) return;

    var tile = card.querySelector('[data-jessie-tile]');
    if (tile) jc().paintTile(tile, row);

    /* "Jessie Premium Elixir™ · #4A3C7A". The separator belongs to the hex, so
       a row without one — there is none in the table today, but the shape is
       the same everywhere — cannot leave a dangling middot. */
    var meta = card.querySelector('[data-jessie-story-meta]');
    if (meta) {
      var parts = [];
      var label = jc().lineLabel(row.line);
      if (label) parts.push(label);
      if (row.hex) parts.push(row.hex);
      if (parts.length) {
        meta.textContent = parts.join(' · ');
        meta.hidden = false;
      }
    }

    var link = card.querySelector('[data-jessie-story-link]');
    if (link && !link.getAttribute('href') && row.url) {
      link.setAttribute('href', row.url);
      link.hidden = false;
    }
  }

  function init() {
    if (!jc()) return;
    jc().ready(function () {
      all(document, '[data-jessie-stories]').forEach(function (section) {
        all(section, '[data-jessie-story]').forEach(fillCard);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
